export const global = {
  servidores_sip() {
    if (process.env.VUE_APP_SITE == "7live") {
      return {
        "ms_wss://g81.fastbetting.app": {
          id: "ms_wss://g81.fastbetting.app",
          tipo: "ms",
          nome: "EUR 1",
          tag: "EUR",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://g81.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://g81.fastbetting.app" },
            { canal: 3, instanceDest: "ms_wss://g81.fastbetting.app" },
            { canal: 4, instanceDest: "ms_wss://g81.fastbetting.app" },
            { canal: 5, instanceDest: "ms_wss://g81.fastbetting.app" },
          ],
        },
        "ms_wss://g86.fastbetting.app": {
          id: "ms_wss://g86.fastbetting.app",
          tipo: "ms",
          nome: "EUR 2",
          tag: "EUR",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://g86.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://g86.fastbetting.app" },
            { canal: 3, instanceDest: "ms_wss://g86.fastbetting.app" },
            { canal: 4, instanceDest: "ms_wss://g86.fastbetting.app" },
            { canal: 5, instanceDest: "ms_wss://g86.fastbetting.app" },
          ],
        },
        "ms_wss://g87.fastbetting.app": {
          id: "ms_wss://g87.fastbetting.app",
          tipo: "ms",
          nome: "BRA 1",
          tag: "BRA",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://g87.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://g87.fastbetting.app" },
          ],
        },
        "ms_wss://c40.fastbetting.app": {
          id: "ms_wss://c40.fastbetting.app",
          tipo: "ms",
          nome: "BRA 2",
          tag: "BRA",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://c40.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://c40.fastbetting.app" },
          ],
        },
        "ms_wss://c50.fastbetting.app": {
          id: "ms_wss://c50.fastbetting.app",
          tipo: "ms",
          nome: "USA 1",
          tag: "USA",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://c50.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://c50.fastbetting.app" },
            { canal: 3, instanceDest: "ms_wss://c50.fastbetting.app" },
          ],
        },
        "ms_wss://c75.fastbetting.app": {
          id: "ms_wss://c75.fastbetting.app",
          tipo: "ms",
          nome: "USA 2",
          tag: "USA",
          limite: 100,
          router: false,
          replyTo: [
            { canal: 1, instanceDest: "ms_wss://c75.fastbetting.app" },
            { canal: 2, instanceDest: "ms_wss://c75.fastbetting.app" },
            { canal: 3, instanceDest: "ms_wss://c75.fastbetting.app" },
          ],
        },
      };
    }

    if (process.env.VUE_APP_SITE == "Share") {
      if (process.env.VUE_APP_VEJA == "false") {
        return {
          "ms_wss://xt301.weddbets.com": {
            id: "ms_wss://xt301.weddbets.com",
            tipo: "ms",
            nome: "Deutschland 1",
            router: false,
            replyTo: [{ canal: 1, instanceDest: "ms_wss://xt301.weddbets.com" }],
          },
          "openvidu_https://sip4.weddbets.com": {
            id: "openvidu_https://sip4.weddbets.com",
            tipo: "openvidu",
            nome: "Deutschland 2",
            router: false,
            replyTo: [],
          },
          "ms_wss://innd1.kwddw.com": {
            id: "ms_wss://innd1.kwddw.com",
            tipo: "ms",
            nome: "India",
            router: false,
            replyTo: [{ canal: 1, instanceDest: "ms_wss://innd1.kwddw.com" }],
          },
          "ms_wss://xt305.weddbets.com": {
            id: "ms_wss://xt305.weddbets.com",
            tipo: "ms",
            nome: "Brazil",
            router: false,
            replyTo: [{ canal: 1, instanceDest: "ms_wss://xt305.weddbets.com" }],
          },
        };
      } else {
        return {
          "ms_wss://v1.veja.ademircarnes.com": {
            id: "ms_wss://v1.veja.ademircarnes.com",
            tipo: "ms",
            nome: "SERVER 1",
            router: false,
            replyTo: [{ canal: 1, instanceDest: "ms_wss://v1.veja.ademircarnes.com" }],
          },
        };
      }
    }

    return {
      "openvidu_https://sip1.weddbets.com": {
        id: "openvidu_https://sip1.weddbets.com",
        tipo: "openvidu",
        nome: "OV SIP1",
        router: false,
        replyTo: [],
      },
      "openvidu_https://sip2.weddbets.com": {
        id: "openvidu_https://sip2.weddbets.com",
        tipo: "openvidu",
        nome: "OV SIP2",
        router: false,
        replyTo: [],
      },
      "openvidu_https://sip3.weddbets.com": {
        id: "openvidu_https://sip3.weddbets.com",
        tipo: "openvidu",
        nome: "OV SIP3",
        router: false,
        replyTo: [],
      },
      "openvidu_https://sip4.weddbets.com": {
        id: "openvidu_https://sip4.weddbets.com",
        tipo: "openvidu",
        nome: "OV SIP4",
        router: false,
        replyTo: [],
      },

      "ms_wss://indd2.kwddw.com": {
        id: "ms_wss://indd2.kwddw.com",
        tipo: "ms",
        nome: "IND 1",
        tag: "INDIA",
        limite: 80,
        router: true,
        replyTo: [],
      },
      "ms_wss://innd1.kwddw.com": {
        id: "ms_wss://innd1.kwddw.com",
        tipo: "ms",
        nome: "IND 2",
        tag: "INDIA",
        limite: 80,
        router: true,
        replyTo: [],
      },
      "ms_wss://ms11.weddbets.com": {
        id: "ms_wss://ms11.weddbets.com",
        tipo: "ms",
        nome: "BRA 1",
        tag: "BRA",
        limite: 80,
        router: true,
        replyTo: [],
      },

      "ms_wss://ms5.weddbets.com": {
        id: "ms_wss://ms5.weddbets.com",
        tipo: "ms",
        nome: "USA 1",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms6.weddbets.com": {
        id: "ms_wss://ms6.weddbets.com",
        tipo: "ms",
        nome: "USA 2",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms1.weddbets.com": {
        id: "ms_wss://ms1.weddbets.com",
        tipo: "ms",
        nome: "USA 3",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms7.weddbets.com": {
        id: "ms_wss://ms7.weddbets.com",
        tipo: "ms",
        nome: "USA 4",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms8.weddbets.com": {
        id: "ms_wss://ms8.weddbets.com",
        tipo: "ms",
        nome: "USA 5",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms13.weddbets.com": {
        id: "ms_wss://ms13.weddbets.com",
        tipo: "ms",
        nome: "USA 6",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://pot2.kwddw.com": {
        id: "ms_wss://pot2.kwddw.com",
        tipo: "ms",
        nome: "USA 7",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms18.weddbets.com": {
        id: "ms_wss://ms18.weddbets.com",
        tipo: "ms",
        nome: "USA 8",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://pot1.kwddw.com": {
        id: "ms_wss://pot1.kwddw.com",
        tipo: "ms",
        nome: "USA 9",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms20.weddbets.com": {
        id: "ms_wss://ms20.weddbets.com",
        tipo: "ms",
        nome: "USA 10",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms21.weddbets.com": {
        id: "ms_wss://ms21.weddbets.com",
        tipo: "ms",
        nome: "USA 11",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms22.weddbets.com": {
        id: "ms_wss://ms22.weddbets.com",
        tipo: "ms",
        nome: "USA 12",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://tape1.kwddw.com": {
        id: "ms_wss://tape1.kwddw.com",
        tipo: "ms",
        nome: "USA 13",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://tape2.kwddw.com": {
        id: "ms_wss://tape2.kwddw.com",
        tipo: "ms",
        nome: "USA 14",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://kf3.kwddw.com": {
        id: "ms_wss://kf3.kwddw.com",
        tipo: "ms",
        nome: "USA 15",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },

      "ms_wss://xhy.kwddw.com": {
        id: "ms_wss://xhy.kwddw.com",
        tipo: "ms",
        nome: "USA 16",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://tx87.kwddw.com": {
        id: "ms_wss://tx87.kwddw.com",
        tipo: "ms",
        nome: "USA 17",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://gtj.kwddw.com": {
        id: "ms_wss://gtj.kwddw.com",
        tipo: "ms",
        nome: "USA 18",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://gfr.kwddw.com": {
        id: "ms_wss://gfr.kwddw.com",
        tipo: "ms",
        nome: "USA 19",
        tag: "USA",
        limite: 80,
        router: false,
        replyTo: [],
      },

      "ms_wss://ms3.weddbets.com": {
        id: "ms_wss://ms3.weddbets.com",
        tipo: "ms",
        nome: "EUR 1",
        rtag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms4.weddbets.com": {
        id: "ms_wss://ms4.weddbets.com",
        tipo: "ms",
        nome: "EUR 2",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms2.weddbets.com": {
        id: "ms_wss://ms2.weddbets.com",
        tipo: "ms",
        nome: "EUR 3",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms9.weddbets.com": {
        id: "ms_wss://ms9.weddbets.com",
        tipo: "ms",
        nome: "EUR 4",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms10.weddbets.com": {
        id: "ms_wss://ms10.weddbets.com",
        tipo: "ms",
        nome: "EUR 5",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms12.weddbets.com": {
        id: "ms_wss://ms12.weddbets.com",
        tipo: "ms",
        nome: "EUR 6",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://pot3.kwddw.com": {
        id: "ms_wss://pot3.kwddw.com",
        tipo: "ms",
        nome: "EUR 7",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ms17.weddbets.com": {
        id: "ms_wss://ms17.weddbets.com",
        tipo: "ms",
        nome: "EUR 8",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://vx1.weddbets.com": {
        id: "ms_wss://vx1.weddbets.com",
        tipo: "ms",
        nome: "EUR 9",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fg10.kwddw.com": {
        id: "ms_wss://fg10.kwddw.com",
        tipo: "ms",
        nome: "EUR 10",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fg11.kwddw.com": {
        id: "ms_wss://fg11.kwddw.com",
        tipo: "ms",
        nome: "EUR 11",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://tape4.kwddw.com": {
        id: "ms_wss://tape4.kwddw.com",
        tipo: "ms",
        nome: "EUR 12",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://tape5.kwddw.com": {
        id: "ms_wss://tape5.kwddw.com",
        tipo: "ms",
        nome: "EUR 13",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://ft10.kwddw.com": {
        id: "ms_wss://ft10.kwddw.com",
        tipo: "ms",
        nome: "EUR 14",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://kf2.kwddw.com": {
        id: "ms_wss://kf2.kwddw.com",
        tipo: "ms",
        nome: "EUR 15",
        tag: "EUR",
        limite: 80,
        router: false,
        replyTo: [],
      },

      "ms_wss://tape3.kwddw.com": {
        id: "ms_wss://tape3.kwddw.com",
        tipo: "ms",
        nome: "BRA 2",
        tag: "BRA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fx4.kwddw.com": {
        id: "ms_wss://fx4.kwddw.com",
        tipo: "ms",
        nome: "BRA 4",
        tag: "BRA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fx5.kwddw.com": {
        id: "ms_wss://fx5.kwddw.com",
        tipo: "ms",
        nome: "BRA 5",
        tag: "BRA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fx6.kwddw.com": {
        id: "ms_wss://fx6.kwddw.com",
        tipo: "ms",
        nome: "BRA 6",
        tag: "BRA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      "ms_wss://fx7.kwddw.com": {
        id: "ms_wss://fx7.kwddw.com",
        tipo: "ms",
        nome: "BRA 7",
        tag: "BRA",
        limite: 80,
        router: false,
        replyTo: [],
      },
      /*"ms_wss://att.kwddw.com": { id: "ms_wss://att.kwddw.com", tipo: "ms", nome: "ATT", tag: "BRA", limite: 80, router: false, replyTo: [] }*/
    };
  },
  servidores_sip_array() {
    return Object.values(this.servidores_sip());
  },
  sites_filtro() {
    if (process.env.VUE_APP_SITE == "7live") {
      return [
        { id: "Todos", nome: "Todos" },
        { id: "7live", nome: "7live" },
      ];
    }

    return [
      { id: "Todos", nome: "Todos" },
      { id: "Weddbets", nome: "Weddbets" },
      { id: "Bll", nome: "Bll" },
      { id: "Extra", nome: "Extra" },
    ];
  },
  sites_filtro_completo() {
    if (process.env.VUE_APP_SITE == "7live") {
      return [
        { id: "Todos", nome: "Todos" },
        { id: "7live", nome: "7live" },
      ];
    }

    return [
      { id: "Todos", nome: "Todos" },
      { id: "Weddbets", nome: "Weddbets" },
      { id: "Bll", nome: "Bll" },
      { id: "Extra", nome: "Extra" },
      { id: "Stream1x2", nome: "Stream 1x2" },
    ];
  },
  tipos_usuarios() {
    return Object.values(this.tipos_usuarios_index());
  },
  tipos_usuarios_index() {
    if (process.env.VUE_APP_SITE == "Weddbets") {
      return {
        Administrador: { id: "Administrador", nome: "Administrador" },
        "Sem acesso": { id: "Sem acesso", nome: "Sem acesso" },
        Teste: { id: "Teste", nome: "Teste" },
        Apresentador: { id: "Apresentador", nome: "Apresentador" },
        Degustação: { id: "Degustação", nome: "Degustação" },
        Assinante: { id: "Assinante", nome: "Assinante" },
        Plano: { id: "Plano", nome: "Plano" },
      };
    }

    if (process.env.VUE_APP_SITE == "Stream1x2") {
      return {
        "Administrador Site": {
          id: "Administrador Site",
          nome: "Administrador Site",
        },
        "Sem acesso": { id: "Sem acesso", nome: "Sem acesso" },
        Teste: { id: "Teste", nome: "Teste" },
        Assinante: { id: "Assinante", nome: "Assinante" },
      };
    }

    if (process.env.VUE_APP_SITE == "Share") {
      if (process.env.VUE_APP_VEJA == "false") {
        return {
          Administrador: { id: "Administrador", nome: "Administrador" },
          Apresentador: { id: "Apresentador", nome: "Apresentador" },
          Assinante: { id: "Assinante", nome: "Assinante" },
        };
      } else {
        return {
          Administrador: { id: "Administrador", nome: "Administrador" },
          Apresentador: { id: "Apresentador", nome: "BOT" },
        };
      }
    }

    if (process.env.VUE_APP_SITE == "7live") {
      return {
        Administrador: { id: "Administrador", nome: "Administrador" },
        Apresentador: { id: "Apresentador", nome: "Bot" },
        "Sem acesso": { id: "Sem acesso", nome: "Sem acesso" },
        Teste: { id: "Teste", nome: "Teste" },
        Degustação: { id: "Degustação", nome: "Degustação" },
        Assinante: { id: "Assinante", nome: "Assinante" },
      };
    }
  },
  comprovantes() {
    if (process.env.VUE_APP_SITE == "Weddbets" || process.env.VUE_APP_SITE == "Bll" || process.env.VUE_APP_SITE == "Stream1x2") {
      return [
        { id: "", nome: "" },
        { id: "Diego", nome: "Diego" },
        { id: "Everton", nome: "Everton" },
        { id: "KT Market", nome: "KT Market" },
        { id: "Marcelo", nome: "Marcelo" },
        { id: "Valerio", nome: "Valerio" },
        { id: "Wilson", nome: "Wilson" },
        { id: "Outros", nome: "Outros" },
      ];
    }

    return [];
  },
  list_avulso() {
    return [
      { id: "nao", nome: "Não" },
      { id: "sim", nome: "Sim" },
    ];
  },
};
